import React from 'react';
import FlightIcon from '@mui/icons-material/Flight';
import BookOnline from '@common/buttons/BookOnline';
import Link from 'next/link';
import { company } from '@components/config/Company';
function AirportTransferBookOnline() {
  return (
    <div className="bg-primary py-10 px-10 flex flex-col items-center justify-center">
      <FlightIcon className="text-7xl text-secondary" />
      <div className="text-center my-10 text-base lg:text-xl text-white">
        Book online or call us today on
        <Link href={`tel:${company[0]?.tel_number}`}>
          <a className="mx-2 text-secondary hover:underline">
            {company[0]?.tel_number}
          </a>
        </Link>
        or
        <Link href={`tel:${company[0]?.tel_number_two}`}>
          <a className="mx-2 text-secondary hover:underline">
            {company[0]?.tel_number_two}
          </a>
        </Link>{' '}
        for the best airport transfers price.
      </div>
      <BookOnline />
    </div>
  );
}

export default AirportTransferBookOnline;
